import { create, get } from '@github/webauthn-json'
import { creationOptions, requestOptions } from './request-constants.js'
import traceService from '../../components/shared/trace/trace-service'
import { THIRD_PARTY_FIDO_METHODS } from '../../utils/constant.js'

export class WebAuthn {
    // credentialId = ''
    rpName;
    user;

    constructor (user, rpName) {
      this.user = user
      this.rpName = rpName
    }

    createCredential = async () => {
      const methodName = THIRD_PARTY_FIDO_METHODS.FIDO_ATTESTATION
      const params = {
        publicKey: {
          ...creationOptions,
          rp: {
            ...creationOptions.rp,
            name: this.rpName
          },
          user: this.user
        }
      }
      traceService.addRequestLogs({
        methodName,
        params
      })
      const credential = await create(params).catch((e) => {
        throw new Error(e.message)
      }
      )
      traceService.addResponseLogs(methodName, credential)
      return credential
    }

    async authenticateCredential (credentialId) {
      const methodName = THIRD_PARTY_FIDO_METHODS.FIDO_ASSERTION
      const params = {
        publicKey: {
          ...requestOptions,
          allowCredentials: [{
            id: credentialId,
            type: 'public-key'
          }]
        }
      }
      traceService.addRequestLogs({
        methodName,
        params
      })
      const response = await get(params).catch((e) => {
        throw new Error(e)
      }
      )
      traceService.addResponseLogs(
        methodName,
        response
      )
      return response
    }
}
